import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { baseQueryConfig } from './config'

const baseQueryAuth = (baseQueryConfig) => {
  const baseQuery = fetchBaseQuery(baseQueryConfig)
  return async (args, api, extraOptions) => {
    const response = await baseQuery(args, api, extraOptions)
    if (!args?.url?.includes('/logout/') && response.error && response.error.status === 401) {
      window.location.href = `/login?next=${window.location.pathname}`
    }
    return response
  }
}

export const baseApi = createApi({
  reducerPath: 'baseApi',

  baseQuery: baseQueryAuth(baseQueryConfig),

  keepUnusedDataFor: 3600,
  endpoints: () => ({}),

  tagTypes: [
    'Application',
    'ApplicationProfile',
    'Alert',
    'Profile',
    'Income',
    'Address',
    'Valuations',
    'Tradeline',
    'Property',
    'PropertyV2',
    'Expense',
    'Subscriber',
    'SubscriberV2',
    'SubscriberWorkQueue',
    'ApplicationWorkQueues',
    'StreamingNote',
    'UserData',
    'TitleOrder',
    'Message',
    'ListOfNotes',
    'ApplicationExceptions',
    'AutomatedApplicationExceptions',
    'ApplicationAllUsersData',
    'CheckListTemplate',
    'Documents',
    'Snapshot',
    'Notifications',
    'DelayReasons',
    'ActivityHistory',
    'CustomerTasks',
    'CustomerStatement',
    'AppraisalOrder',
    'Escalations',
    'Companies',
    'UseOfProceeds',
    'Asset',
    'Declaration',
    'IncomeV2',
    'Override',
    'ApplicationOffer',
    'ApplicationGuidelines',
    'ApplicationCount',
    'ValuationV2',
    'AtypicalityCheckV2',
    'AtypicalityCheckCalcs',
    'ApplicationCalcs',
    'ChecklistGroups',
    'ApplicationProfiles',
    'ApplicationParties',
    'WorkQueuesPresets',
    'Dscr',
    'ApplicationMonthlyIncome',
    'ApplicationProfileMonthlyIncome',
    'UserIncomes',
    'PipelineApplications',
    'Liens',
    'Payoffs',
    'DealTeam',
    'AuthMethod',
    'HOI',
    'DocumentReview',
    'DocumentMetadata',
    'DocumentMetadataAuditCheck',
    'DocRequest',
    'USStates',
    'PropertyFlag',
    'DocumentTemplate',
    'MaxActions',
    'TitleReport',
    'Bankruptcy',
    'Hoa',
    'FloodReport',
    'AvailableApiKey',
    'ThirdPartyUsers',
    'PropertyDetails',
    'ApplicationPricingVersion',
    'Consts',
    'LavaReport',
  ],
})
